function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1,.primary{fill:none;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "cls-1",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("circle", {
  className: "highlights",
  cx: 59.42,
  cy: 135.73,
  r: 31.62
}), React.createElement("circle", {
  className: "highlights",
  cx: 181.66,
  cy: 75.97,
  r: 31.62
}), React.createElement("circle", {
  className: "highlights",
  cx: 179.9,
  cy: 193.46,
  r: 31.62
})), React.createElement("g", {
  id: "primary"
}, React.createElement("circle", {
  className: "primary",
  cx: 68.05,
  cy: 127.42,
  r: 36.22
}), React.createElement("circle", {
  className: "primary",
  cx: 187.78,
  cy: 68.06,
  r: 36.22
}), React.createElement("circle", {
  className: "primary",
  cx: 186.77,
  cy: 186.78,
  r: 36.22
}), React.createElement("line", {
  className: "primary",
  x1: 106.39,
  y1: 107.72,
  x2: 153.73,
  y2: 83.81
}), React.createElement("line", {
  className: "primary",
  x1: 102.71,
  y1: 143.13,
  x2: 152.29,
  y2: 169.25
})));
var SvgSocialAlt = function SvgSocialAlt(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSocialAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SocialAlt.4a9e6a28.svg";
export { ForwardRef as ReactComponent };